
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CardImage',
  props: {
    source: {
      type: String,
      required: true,
    },
  },
});
